import { MediaToolsProviderService } from '@addins/core/singlecallcard';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { ProfileReaderService } from '@services/profile-reader/profile-reader.service';
import { ProfileService } from '@services/profile/profile.service';
import { Tool } from '@services/tools';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { filter, first } from 'rxjs';
import { MediaSource } from '../../../schema/enums/media-source';
import { AttachmentService } from '../../attachment/attachment.service';
import { MediaTextMessageService } from '../../media-text-message/media-text-message.service';

enum MediaMessageSource {
  Text = 'Text',
  Camera = 'Camera',
  Gallery = 'Gallery',
  Video = 'Video',
  File = 'File'
}

@AddinExecute({
  name: 'Add media tools'
})
@Injectable()
export class MediaToolsSetupService extends Execute {
  public constructor(
    private profileService: ProfileService,
    private profileReader: ProfileReaderService,
    private mediaToolsProvider: MediaToolsProviderService,
    private attachments: AttachmentService,
    private textMessage: MediaTextMessageService,
    private platform: Platform
  ) {
    super();
  }

  execute() {
    this.profileService.ready
      .pipe(
        filter(isReady => isReady),
        first()
      )
      .subscribe(() => this.onProfileReady());
  }

  private onProfileReady() {
    const mediaSources: string[] = this.profileReader.getComponentConfig('Media', 'canAddMediaMessageFrom', [
      MediaMessageSource.Text,
      MediaMessageSource.Camera,
      MediaMessageSource.Gallery,
      MediaMessageSource.Video
    ]);
    this.addMediaTools(mediaSources);
  }

  private addMediaTools(mediaSources: string[]) {
    mediaSources.forEach(mediaSource => {
      switch (mediaSource) {
        case MediaMessageSource.Text:
          const mediaMessageTool = new Tool('SagaSchema.MediaMessage', 'text', '', 0, context =>
            this.textMessage.createTextMessage(context.callcard)
          );
          this.mediaToolsProvider.register(mediaMessageTool);
          break;

        case MediaMessageSource.Camera:
          const cameraTool = new Tool('Saga.AttachmentType.Picture', 'camera', '', 1, context =>
            this.createMediaMessage(context.callcard.ObjGuid, MediaSource.Camera)
          );
          this.mediaToolsProvider.register(cameraTool);
          break;

        case MediaMessageSource.Gallery:
          if (this.platform.is('cordova')) {
            const galleryTool = new Tool('Saga.AttachmentType.Gallery', 'image', '', 2, context =>
              this.createMediaMessage(context.callcard.ObjGuid, MediaSource.Gallery)
            );
            this.mediaToolsProvider.register(galleryTool);
          }
          break;

        case MediaMessageSource.Video:
          const videoTool = new Tool('Saga.AttachmentType.Camera', 'videocam', '', 3, context =>
            this.attachments.createMediaMessage(context.callcard.ObjGuid, MediaSource.Video)
          );
          this.mediaToolsProvider.register(videoTool);
          break;

        case MediaMessageSource.File:
          const fileTool = new Tool('Saga.AttachmentType.File', 'document', '', 4, callcard =>
            this.attachments.createMediaMessage(callcard.ObjGuid, MediaSource.File)
          );
          this.mediaToolsProvider.register(fileTool);
          break;
      }
    });
  }

  private createMediaMessage(callcardId: string, source: MediaSource) {
    this.attachments.createMediaMessage(callcardId, source);
  }
}
